// utils/localStorageUtil.ts


type StorageKey = "guestId" | string;

/**
 * 从 localStorage 获取数据并解析为 JSON 对象。
 * @param {StorageKey} key 存储在 localStorage 中的键。
 * @returns {T | null} 返回存储的数据，如果键不存在或解析失败则返回 null。
 */
export function getItem<T>(key: StorageKey | string): T | null {
  if (typeof window === "undefined") {
    return null;
  } // 确保在客户端环境中运行
  const item = window.localStorage.getItem(key);
  if (!item) {
    return null;
  }
  try {
    return JSON.parse(item) as T;
  } catch (error) {
    return null;
  }
}

/**
 * 将数据序列化为 JSON 字符串并存储在 localStorage 中。
 * @param {StorageKey} key 存储在 localStorage 中的键。
 * @param {T} value 要存储的数据。
 */
export function setItem<T>(key: StorageKey | string, value: T): void {
  if (typeof window === "undefined") {
    return;
  } // 确保在客户端环境中运行
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    // Error setting item in localStorage
  }
}

/**
 * 从 localStorage 中移除指定键的数据。
 * @param {StorageKey} key 存储在 localStorage 中的键。
 */
export function removeItem(key: StorageKey): void {
  if (typeof window === "undefined") {
    return;
  } // 确保在客户端环境中运行
  window.localStorage.removeItem(key);
}

/**
 * 清除 localStorage 中的所有数据。
 */
export function clearStorage(excludeKeys: string[] = []): void {
  if (typeof window === "undefined") {
    return;
  }

  const preserved: Record<string, string> = {};
  excludeKeys.forEach(key => {
    const value = window.localStorage.getItem(key);
    if (value) {
      preserved[key] = value;
    }
  });

  window.localStorage.clear();

  Object.entries(preserved).forEach(([key, value]) => {
    window.localStorage.setItem(key, value);
  });
}


